import axios from './request'
/**
 * type: [application/x-www-form-urlencoded]
 * url: [请求地址]
 * data: [携带参数]
 **/
export function formPost(url, data) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            url: url,
            data: data
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}


/**
 * type: [application/json]
 * url: [请求地址]
 * data: [携带参数]
 **/
export function resPost(url,query,data) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: url,
            params: query,
            data,
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}


/**
 * type: [blob]
 * url: [请求地址]
 * data: [携带参数]
 **/
export function blobGet(url, data) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'GET',
            url: url,
            data: data,
            responseType: 'blob'
        }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * type: [blob]
 * url: [请求地址]
 * data: [携带参数]
 **/
export function blobPost(url, data) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'POST',
            url: url,
            data: data,
            responseType: 'blob'
        }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err)
        })
    })
}


/**
 * type: [application/json]
 * url: [请求地址]
 * data: [携带参数]
 **/
export function resGet(url, data) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'GET',
            url: url,
            params: data,
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * type: [multipart/form-data]
 * url: [请求地址]
 * data: [携带参数]
 **/
export function multPost(url, data) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'POST',
            url: url,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryrHyAYW2WBUNBT0lx'
            },
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}
/**
 * type: [并行请求]
 * url: [请求地址]
 * data: [携带参数]
 **/
export function allPost(url) {
    return new Promise((resolve, reject) => {
        axios.all(url).then(axios.spread(function (a, b, c) {
            resolve([a, b, c])
        })).catch(err => {
            reject(err)
        })
    })
}